import React, { type DetailedHTMLProps, type HTMLAttributes } from 'react';

import styled, { createGlobalStyle } from 'styled-components';

const DialogFooterDiv = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <>
      <div data-dialog-footer {...props} />
      <IosPwaFix />
    </>
  );
};

const DialogFooter = styled(DialogFooterDiv)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #00000026;
`;

const IosPwaFix = createGlobalStyle`
  .ios-pwa {
    ${DialogFooter} {
      padding: 16px 16px 32px;
    }
  }
`;

export { DialogFooter };
